module.exports = __webpack_public_path__ + "img/I-BOS-1136-0.fa02b89d.png";